import React, { useState, useEffect } from "react";
import { Variables } from "../../Variables1/Variables";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Row, Col, Modal, Button, Form, Card } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import CustomSnipper from "../../components/customSnipper";
import Util from "../../Classes/Util";
import { BiLowVision } from "react-icons/bi";
import Cookies from "js-cookie";
import Pagination from "../../components/Pagination";

var sortJsonArray = require("sort-json-array");

function ContentsList(props) {
  const navigate = useNavigate();
  const token = Cookies.get("token");
  const [loader, setLoader] = useState(false);
  const [contents, setContents] = useState([]);
  const [publishModelShow, setPublishModelShow] = useState(0);
  const [searchInput, setSearchInput] = useState(""); // text currently typed in the box
  const [searchTerm, setSearchTerm] = useState(""); // committed term sent to the API
  const [orderBy, setOrderBy] = useState("alphabetical"); // "alphabetical" | "menuOrder"
  const [filteredData, setFilteredData] = useState([]);
  const [Permissions, setPermissions] = useState(
    Util.decrypt(localStorage.getItem("rpmRRTLx12"))
  );

  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  // Get Contents list
  const GetContentsList = async () => {
  setLoader(true);
  let response = await fetch(
    `${Variables.API_URL}Content/GetContentsList?pageNumber=${pageNumber}&pageSize=${pageSize}&searchTerm=${encodeURIComponent(
      searchTerm
    )}&orderBy=${encodeURIComponent(orderBy)}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    }
  );
  let result = await response.json();
  if (response.status === 200) {
    setContents(result.Items);
    setFilteredData(result.Items);
    setTotalCount(result.TotalCount);
  }
  setLoader(false);
};

  // Run the search across ALL products (all pages). Reset to page 1 so results
  // are visible; committing searchTerm triggers the fetch via useEffect.
  const handleSearchSubmit = () => {
    setPageNumber(1);
    setSearchTerm(searchInput.trim());
  };

  // Clear the search and go back to the full list
  const handleClearSearch = () => {
    setSearchInput("");
    setPageNumber(1);
    setSearchTerm("");
  };

  // Change the ordering (menu order / alphabetical) per category
  const handleOrderByChange = (event) => {
    setPageNumber(1);
    setOrderBy(event.target.value);
  };

  // Publish / Unpublish content
  const PublishUnpublishContent = async (contentId) => {
    let response = await fetch(
      Variables.API_URL + "Content/PublishUnpublishContent/" + contentId,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    let result = await response.json();
    if (response.status === 200) {
      toast.success(result, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setPublishModelShow(0);
      GetContentsList();
    } else {
      toast.error(result, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  //#region Sorting

  const [titleSort, setTitleSort] = useState("asc");
  const [menuSort, setMenuSort] = useState("asc");
  const [albumSort, setAlbumSort] = useState("asc");
  const [authorSort, setAuthorSort] = useState("asc");
  const [languageSort, setLanguageSort] = useState("asc");
  const [publishSort, setPublishSort] = useState("asc");

  // sort by title
  const SortByTitle = () => {
    var copy = [...filteredData];
    if (titleSort == "asc") {
      var x = sortJsonArray(copy, "Title", "des");
      setTitleSort("des");
    } else {
      var x = sortJsonArray(copy, "Title");
      setTitleSort("asc");
    }
    setFilteredData(x);
  };

  // sort by Menu
  const SortByMenu = () => {
    var copy = [...filteredData];
    if (menuSort == "asc") {
      var x = sortJsonArray(copy, "MenuName", "des");
      setMenuSort("des");
    } else {
      var x = sortJsonArray(copy, "MenuName");
      setMenuSort("asc");
    }
    setFilteredData(x);
  };

  // sort by Album
  const SortByAlbum = () => {
    var copy = [...filteredData];
    if (albumSort == "asc") {
      var x = sortJsonArray(copy, "AlbumName", "des");
      setAlbumSort("des");
    } else {
      var x = sortJsonArray(copy, "AlbumName");
      setAlbumSort("asc");
    }
    setFilteredData(x);
  };

  // sort by Author
  const SortByAuthor = () => {
    var copy = [...filteredData];
    if (authorSort == "asc") {
      var x = sortJsonArray(copy, "AuthorName", "des");
      setAuthorSort("des");
    } else {
      var x = sortJsonArray(copy, "AuthorName");
      setAuthorSort("asc");
    }
    setFilteredData(x);
  };

  // sort by Language
  const SortByLanguage = () => {
    var copy = [...filteredData];
    if (languageSort == "asc") {
      var x = sortJsonArray(copy, "LanguageName", "des");
      setLanguageSort("des");
    } else {
      var x = sortJsonArray(copy, "LanguageName");
      setLanguageSort("asc");
    }
    setFilteredData(x);
  };

  // sort by Publish
  const SortByPublish = () => {
    var copy = [...filteredData];
    if (publishSort == "asc") {
      var x = sortJsonArray(copy, "IsPublished", "des");
      setPublishSort("des");
    } else {
      var x = sortJsonArray(copy, "IsPublished");
      setPublishSort("asc");
    }
    setFilteredData(x);
  };

  //#endregion

  useEffect(() => {
  GetContentsList();
}, [pageNumber, pageSize, searchTerm, orderBy]);


  return (
    <div>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">Contents List</h4>
              </div>
              {Permissions.ManageContents === true && (
                <Button
                  variant="primary"
                  onClick={() => navigate("/Content/0")}
                >
                  Add New Content
                </Button>
              )}
            </Card.Header>
            <Card.Body className="px-0">
              <Row className="px-3 mb-3 g-2 align-items-end">
                <Col md="7" sm="12">
                  <Form.Label htmlFor="Search">Search all products</Form.Label>
                  <div className="d-flex">
                    <Form.Control
                      id="Search"
                      name="Search"
                      placeholder="Search by title, menu, album, author, language or reference..."
                      type="text"
                      value={searchInput}
                      onChange={(e) => setSearchInput(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") handleSearchSubmit();
                      }}
                    />
                    <Button
                      variant="primary"
                      className="ms-2 text-nowrap"
                      onClick={handleSearchSubmit}
                    >
                      Search
                    </Button>
                    {searchTerm !== "" && (
                      <Button
                        variant="outline-secondary"
                        className="ms-2 text-nowrap"
                        onClick={handleClearSearch}
                      >
                        Clear
                      </Button>
                    )}
                  </div>
                </Col>
                <Col md="5" sm="12">
                  <Form.Label htmlFor="OrderBy">Order by</Form.Label>
                  <select
                    id="OrderBy"
                    name="OrderBy"
                    className="form-control"
                    value={orderBy}
                    onChange={handleOrderByChange}
                  >
                    <option value="alphabetical">Alphabetical</option>
                    <option value="menuOrder">Menu order</option>
                  </select>
                </Col>
              </Row>
              {loader === true ? (
                <CustomSnipper />
              ) : (
                <div className="table-responsive">
                  <table
                    id="user-list-table"
                    className="table table-striped"
                    role="grid"
                    data-toggle="data-table"
                  >
                    <thead>
                      <tr className="ligth">
                        <th>#</th>
                        <th></th>
                        <th onClick={() => SortByTitle()}>Title</th>
                        <th onClick={() => SortByMenu()}>Menu</th>
                        <th onClick={() => SortByAlbum()}>Album</th>
                        <th onClick={() => SortByAuthor()}>Author</th>
                        <th onClick={() => SortByLanguage()}>Language</th>
                        <th onClick={() => SortByPublish()}>IsPublished</th>
                        <th min-width="100px">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.map((tdata, index) => (
                        <tr key={index}>
                          <td className="text-center">{index + 1}</td>
                          <td className="text-center">
                            <img
                              src={Variables.imagePath + tdata.ImageUrl}
                              className="bg-soft-primary rounded img-fluid avatar-40 me-3"
                              alt="Boat on Calm Water"
                            />
                          </td>
                          <td>{tdata.Title}</td>
                          <td>{tdata.MenuName}</td>
                          <td>{tdata.AlbumName}</td>
                          <td>{tdata.AuthorName}</td>
                          <td>{tdata.LanguageName}</td>
                          <td>
                            <span
                              className={
                                tdata.IsPublished === false
                                  ? "badge bg-danger"
                                  : "badge bg-success"
                              }
                            >
                              {tdata.IsPublished === false
                                ? "Unpublished"
                                : "Published"}
                            </span>
                          </td>
                          <td>
                            {Permissions.ManageContents === true && (
                              <div className="flex align-items-center list-user-action">
                                <Link
                                  className="btn btn-sm btn-icon btn-warning"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title=""
                                  data-original-title="Lock"
                                  to="#"
                                  onClick={() =>
                                    setPublishModelShow(tdata.ContentId)
                                  }
                                >
                                  <BiLowVision />
                                </Link>{" "}
                                <Modal
                                  show={tdata.ContentId === publishModelShow}
                                  onHide={() => setPublishModelShow(0)}
                                >
                                  <Modal.Header closeButton>
                                    <Modal.Title as="h5">
                                      {tdata.IsPublished
                                        ? "Unpublish Content"
                                        : "Publish Content"}
                                    </Modal.Title>
                                  </Modal.Header>
                                  <Modal.Body>
                                    Are you sure you want to{" "}
                                    {tdata.IsPublished
                                      ? "Unpublish : "
                                      : "Publish : "}
                                    <b>{tdata.Title}</b>?
                                  </Modal.Body>
                                  <Modal.Footer>
                                    <Button
                                      variant="secondary"
                                      onClick={() => setPublishModelShow(0)}
                                    >
                                      Close
                                    </Button>
                                    <Button
                                      variant="primary"
                                      onClick={() =>
                                        PublishUnpublishContent(tdata.ContentId)
                                      }
                                    >
                                      Save changes
                                    </Button>
                                  </Modal.Footer>
                                </Modal>
                                <Link
                                  className="btn btn-sm btn-icon btn-success"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title=""
                                  data-original-title="Edit"
                                  to={"/Content/" + tdata.ContentId}
                                >
                                  <span className="btn-inner">
                                    <svg
                                      width="20"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      ></path>
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      ></path>
                                      <path
                                        d="M15.1655 4.60254L19.7315 9.16854"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      ></path>
                                    </svg>
                                  </span>
                                </Link>{" "}
                              </div>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <Pagination
                    pageNumber={pageNumber}
                    totalCount={totalCount}
                    pageSize={pageSize}
                    onPageChange={(newPage) => setPageNumber(newPage)}
                  />

                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default ContentsList;
